import { ApiResponse } from '@nf/types/api';
import { ApiBackendInfo, AthenaSiteConfig } from './types';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { useApiBackendInfo } from '../use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums } from '@nf/types/site';


export const fetchAthenaSiteConfig = async (apiBackendInfo: ApiBackendInfo): Promise<ApiResponse<AthenaSiteConfig>> => {
	const response = await fetchComposer.postWithBearer(`${apiBackendInfo.url}/Config/GetAthenaSiteConfig`)(apiBackendInfo.token);
	if (!response.ok) {
		throw new Error(`${response.status}: ${response.statusText}`);
	}
	return await response.json();
};

export const useAthenaSiteConfig = () => {
	const isAthena = siteService.getLicenseeType() === LicenseeTypeEnums.Athena;
	const apiBackendInfo = useApiBackendInfo();
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [queryKeys.ATHENA_SITE_CONFIG, apiBackendInfo.url, apiBackendInfo.token],
		queryFn: () => fetchAthenaSiteConfig(apiBackendInfo),
		refetchOnWindowFocus: false,
		staleTime: 1000 * 30,
		cacheTime: 1000 * 60,
		enabled: isAthena && apiBackendInfo.isReady
	});

	return {
		data: data?.Data,
		isLoading,
		isError,
		error,
		refetch
	};
};